import React, { useEffect } from 'react';
import Header from "../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { GetServicesThunk } from "../../redux/thunks/GetServicesThunk";
import ServicesSchedule from "../../components/ServicesSchedule/ServicesSchedule";
import ServicesHeader from "../../components/PagesHeaders/ServicesHeader/ServicesHeader";
import ServicesForm from "../../components/ServicesForm/ServicesForm";
import { setServicesFormAction } from "../../redux/rootReducer";
import { SERVICES_FORM_INITIAL } from "../../redux/initialStateConstant";
import ServicesSettings from "../../components/ServicesSettings/ServicesSettings";

const Services = () => {
    const dispatch = useDispatch();
    const services = useSelector(state => state.services);
    const services_settings = useSelector(state => state.services_settings);

    // Обработчик нажатия на клавиатуру
    const keyDownHandler = event => {
        if (event.key === 'Escape') {
            dispatch(setServicesFormAction(SERVICES_FORM_INITIAL));
        }
    };

    useEffect(() => {
        dispatch(GetServicesThunk({ date: services.date }));

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        }
    }, [dispatch]);

    return (
        <>
            <Header component={ <ServicesHeader/> }/>
            <ServicesForm/>
            <div className="page">
                {
                    services_settings.open
                    ?
                    <ServicesSettings/>
                    :
                    <div className="schedule">
                        <ServicesSchedule/>
                    </div>
                }
            </div>
        </>
    );
};

export default Services;